module.exports = __webpack_public_path__ + "img/NZ.262bdd4f.svg";